import { useFlags } from "launchdarkly-react-client-sdk";
import { IEPStatus, PlanType } from "../@types";
import { PlanCoverageStatus, useBeneCoverage } from "./useBeneCoverage";
import { hasGlobalSession } from "./loginHelpers";
import { useContext } from "react";
import { AppContext } from "../app/store";
import { useIEPStatus } from "./useIEPStatus";

/** hook to determine if we should show Medigap Open Enrollment Period Alerts (for New To Medicare) */
export function useMOEPAlert() {
  // * New To Medicare Flag (required)
  const { tmpFeEnableNewToMedicare } = useFlags();

  // * Logged In
  const {
    state: { newToMedicareAlertInfo },
    state,
  } = useContext(AppContext);
  const isLoggedIn = hasGlobalSession(state);

  // * Bene Coverage
  const { hasAnyCoverage } = useBeneCoverage();

  /** we do not want to show alerts if the user has certain plans already. */
  const hasProperMOEPCoverage =
    // does not have current or future Medigap
    !hasAnyCoverage(
      PlanType.MEDIGAP,
      PlanCoverageStatus.Current,
      PlanCoverageStatus.Future
    ) &&
    // does not have current, future, or pending Medicare Advantage
    !hasAnyCoverage(PlanType.MA) &&
    // does not have current, future, or pending Medicare Advantage + Part D
    !hasAnyCoverage(PlanType.MAPD);

  // * IEP Status

  const { iepStatus } = useIEPStatus();

  const isWithinOrBeforeIEP =
    iepStatus &&
    [IEPStatus.IEP_STATUS_BEFORE_IEP, IEPStatus.IEP_STATUS_WITHIN_IEP].includes(
      iepStatus
    );

  const showForLoggedInBene =
    isLoggedIn && isWithinOrBeforeIEP && hasProperMOEPCoverage;
  const showForAnonBene =
    !isLoggedIn && !!newToMedicareAlertInfo?.newToMedicareResult;

  const showMOEPMessaging =
    !!tmpFeEnableNewToMedicare && (showForLoggedInBene || showForAnonBene);

  return { showMOEPMessaging };
}
